import { jsxs as g, jsx as i, Fragment as B } from "react/jsx-runtime";
import { useState as j } from "react";
import { Iconify as A } from "../Iconify/index.js";
import { alpha as y, lighten as E, getContrastColor as R, GREY as f, hex2rgb as G } from "../../utils/colors.js";
import { n as x } from "../../emotion-styled.browser.esm-Br5Hs_hj.js";
import O from "./PhoneField.js";
const S = "fitness-5-option-3", W = "fitness-5-option-4";
function P(t, r, e) {
  return t.every((n) => {
    var d, l;
    return typeof e[n] == "object" ? (console.log({ answers: Object.values(e[n]) }), (((l = (d = r.find((a) => a.id === n)) == null ? void 0 : d.options) == null ? void 0 : l.map((a) => a.id)) || []).every((a) => {
      var b, m;
      return a === S ? ((b = e[n][a]) == null ? void 0 : b.code) && ((m = e[n][a]) == null ? void 0 : m.phone) : a === W ? !0 : e[n][a];
    })) : e[n];
  });
}
var _ = /* @__PURE__ */ ((t) => (t.DK = "DK", t.EN = "EN", t))(_ || {}), K = /* @__PURE__ */ ((t) => (t.RADIO = "radio", t.TEXT = "text", t.LONG_TEXT = "long_text", t.NUMBER = "number", t.CONTACT = "contact", t))(K || {});
function ie({
  defaultCountryCode: t,
  answers: r,
  updateAnswer: e,
  questions: n = [],
  initialActive: d,
  customColor: l,
  handleSubmit: s,
  previousText: a,
  submitText: b,
  nextText: m,
  submitting: I = !1
}) {
  const [u, C] = j(d), z = () => {
    C((o) => {
      const p = n.findIndex((h) => h.id === o) + 1;
      return p < n.length ? n[p].id : o;
    });
  }, L = () => {
    C((o) => {
      const p = n.findIndex((h) => h.id === o) - 1;
      return p >= 0 ? n[p].id : o;
    });
  }, D = (o, c) => {
    e(o, c), setTimeout(() => {
      z();
    }, 200);
  }, T = (o, c) => {
    e(o, c);
  }, N = (o, c, p, h) => {
    c === S ? h === "countryCode" ? e(o, {
      ...r[o],
      [c]: { ...r[o][c], code: p }
    }) : e(o, {
      ...r[o],
      [c]: { ...r[o][c], phone: p }
    }) : e(o, { ...r[o], [c]: p });
  }, F = n.map((o) => o.id), w = P(F, n, r);
  return console.log({ isAllAnswered: w }), /* @__PURE__ */ g(
    "div",
    {
      style: {
        boxSizing: "border-box",
        display: "flex",
        flexFlow: "wrap",
        marginTop: "-24px",
        width: "calc(100% + 24px)",
        marginLeft: "-24px",
        maxWidth: "350px"
      },
      children: [
        /* @__PURE__ */ g(
          "div",
          {
            style: {
              display: "block",
              flexDirection: "row",
              flexBasis: "100%",
              flexGrow: 0,
              margin: 0,
              paddingLeft: 24,
              paddingTop: 24
            },
            children: [
              /* @__PURE__ */ i("div", { style: { width: "50%" }, children: /* @__PURE__ */ i(
                M,
                {
                  steps: F,
                  active: u,
                  setActive: C,
                  customColor: l
                }
              ) }),
              n.map((o) => (
                // <Fade in={q.id === active} timeout={500}>
                /* @__PURE__ */ g(
                  "div",
                  {
                    style: { display: o.id === u ? "inherit" : "none" },
                    children: [
                      /* @__PURE__ */ i(
                        "p",
                        {
                          style: {
                            fontSize: 24,
                            margin: 0,
                            marginTop: 4,
                            marginBottom: 12,
                            fontFamily: "inherit"
                          },
                          children: o.content
                        }
                      ),
                      o.type === "number" && /* @__PURE__ */ i(
                        U,
                        {
                          placeholder: o.placeholder || o.content,
                          customColor: l,
                          handleAnswer: (c) => T(o.id, c)
                        }
                      ),
                      o.type === "long_text" && /* @__PURE__ */ i(
                        X,
                        {
                          placeholder: o.placeholder || o.content,
                          customColor: l,
                          handleAnswer: (c) => T(o.id, c)
                        }
                      ),
                      o.type === "radio" && /* @__PURE__ */ i(
                        V,
                        {
                          value: r[o.id],
                          handleSelectOption: (c) => D(o.id, c),
                          options: o.options,
                          customColor: l
                        }
                      ),
                      o.type === "contact" && /* @__PURE__ */ i(
                        Y,
                        {
                          defaultCountryCode: t,
                          handleAnswer: (c, p, h) => N(o.id, c, p, h),
                          options: o.options,
                          customColor: l
                        }
                      )
                    ]
                  },
                  o.id
                )
              ))
            ]
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            style: {
              display: "block",
              flexDirection: "row",
              flexBasis: "100%",
              flexGrow: 0,
              margin: 0,
              paddingLeft: 24,
              paddingTop: 24
            },
            children: /* @__PURE__ */ g(
              "div",
              {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 16
                },
                children: [
                  /* @__PURE__ */ i("div", { style: { flexGrow: 1 }, children: n[0].id !== u && /* @__PURE__ */ i(
                    $,
                    {
                      size: "large",
                      customColor: l,
                      onClick: L,
                      children: a
                    }
                  ) }),
                  /* @__PURE__ */ i("div", { style: { flexGrow: 2 }, children: u === n[n.length - 1].id ? /* @__PURE__ */ i(
                    $,
                    {
                      size: "large",
                      variant: "contained",
                      loading: I,
                      disabled: !w,
                      customColor: l,
                      onClick: s,
                      children: b
                    }
                  ) : /* @__PURE__ */ i(
                    $,
                    {
                      size: "large",
                      variant: "contained",
                      disabled: !r[u],
                      customColor: l,
                      onClick: z,
                      children: m
                    }
                  ) })
                ]
              }
            )
          }
        )
      ]
    }
  );
}
function M({
  steps: t,
  active: r,
  setActive: e,
  customColor: n
}) {
  return /* @__PURE__ */ i(v, { direction: "row", spacing: 0.5, children: t.map((d) => {
    const l = 100 / (t.length + 1), s = d === r;
    return /* @__PURE__ */ i(
      k,
      {
        sx: {
          borderTop: "8px solid transparent",
          borderBottom: "8px solid transparent",
          transition: "all 0.2s ease-in-out",
          width: `${s ? l * 1.5 : l}%`,
          cursor: "pointer"
        },
        onClick: () => e(d),
        children: /* @__PURE__ */ i(
          k,
          {
            sx: {
              borderRadius: 4,
              height: 4,
              backgroundColor: s ? n : f[300]
            }
          }
        )
      },
      d
    );
  }) });
}
function X({
  placeholder: t,
  customColor: r,
  handleAnswer: e
}) {
  return /* @__PURE__ */ i(v, { spacing: 1.5, children: /* @__PURE__ */ i(
    Q,
    {
      placeholder: t,
      rows: 4,
      customColor: r,
      onChange: (n) => e(n.target.value)
    }
  ) });
}
function U({
  placeholder: t,
  customColor: r,
  handleAnswer: e
}) {
  return /* @__PURE__ */ i(v, { spacing: 1.5, children: /* @__PURE__ */ i(
    J,
    {
      placeholder: t,
      type: "number",
      variant: "outlined",
      onChange: (n) => e(n.target.value),
      customColor: r
    }
  ) });
}
function V({
  value: t,
  options: r,
  customColor: e,
  handleSelectOption: n
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: r.map((l) => /* @__PURE__ */ i(B, { children: /* @__PURE__ */ g(
        H,
        {
          customColor: e,
          variant: "text",
          size: "large",
          onClick: () => n(l.content),
          children: [
            l.content,
            l.content === t && /* @__PURE__ */ i(
              k,
              {
                style: {
                  display: "flex",
                  position: "absolute",
                  right: -(24 / 2),
                  zIndex: 1
                },
                children: /* @__PURE__ */ i(
                  v,
                  {
                    style: {
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      position: "relative",
                      height: 24,
                      width: 24,
                      borderRadius: "50%",
                      backgroundColor: "#0DA800"
                    },
                    children: /* @__PURE__ */ i(
                      A,
                      {
                        icon: "zondicons:checkmark",
                        width: 24 / 2,
                        height: 24 / 2,
                        style: {
                          color: "#fff",
                          position: "relative",
                          zIndex: 1
                        }
                      }
                    )
                  }
                )
              }
            )
          ]
        },
        l.id
      ) }))
    }
  );
}
function Y({
  defaultCountryCode: t,
  options: r,
  customColor: e,
  handleAnswer: n
}) {
  return (
    // STACK
    /* @__PURE__ */ i("div", { style: { display: "flex", flexDirection: "column", gap: 8 }, children: r.map((d) => {
      var s;
      const l = ((s = d.label) == null ? void 0 : s.toLowerCase()) === "email";
      return d.id === S ? /* @__PURE__ */ i(
        O,
        {
          customColor: e,
          onCountryChange: (a) => n(d.id, a, "countryCode"),
          onChange: (a) => n(d.id, a),
          placeholder: d.placeholder || d.content || "Phone",
          defaultCountryCode: t
        }
      ) : /* @__PURE__ */ i(B, { children: /* @__PURE__ */ i(
        Z,
        {
          label: d.label,
          placeholder: d.placeholder || d.content,
          customColor: e,
          onInput: (a) => n(d.id, a.target.value),
          type: l ? "email" : "text",
          required: !0
        },
        d.id
      ) });
    }) })
  );
}
const H = x.button((t) => {
  const r = y("#161618", 0.08);
  let e = "inherit", n = "#161618";
  return t.customColor && (e = E(t.customColor, 0.9), n = R(e, !0)), {
    cursor: "pointer",
    display: "flex",
    border: "none",
    transition: "all 0.2s ease-in-out",
    justifyContent: "flex-start",
    paddingLeft: 16,
    paddingTop: 14,
    alignItems: "center",
    paddingBottom: 14,
    fontSize: 14,
    fontWeight: 500,
    textAlign: "left",
    position: "relative",
    color: n,
    //theme.palette.getContrastText(props.customColor), //'#222',
    textTransform: "none",
    borderRadius: 8,
    backgroundColor: "#fff",
    fontFamily: "inherit",
    // border: `1px solid ${GREY[100]}`,
    boxShadow: `0 0px 16px 2px ${r}`,
    zIndex: 1,
    "&:hover": {
      color: n,
      backgroundColor: e,
      boxShadow: `0 0px 16px 2px ${r}`
    }
  };
}), $ = x.button((t) => {
  const { customColor: r, flatButton: e, disabled: n } = t;
  if (!r)
    return {};
  const d = n ? f[200] : r, [l, s, a] = G(d);
  return t.variant === "contained" ? {
    fontWeight: 600,
    width: "100%",
    fontSize: 14,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 22,
    paddingRight: 22,
    transition: "all 0.2s ease-in-out",
    borderRadius: 8,
    textTransform: "none",
    opacity: n ? 0.5 : 1,
    border: `2px solid ${d}`,
    cursor: n ? "not-allowed" : "pointer",
    color: R(d, !0),
    backgroundColor: d,
    fontFamily: "inherit",
    boxShadow: e ? "none" : `0 4px 8px 0 rgb(${l} ${s} ${a} / 24%)`,
    "&:hover": {
      boxShadow: e ? "none" : `0 2px 4px 0 rgb(${l} ${s} ${a} / 24%)`,
      backgroundColor: d
    }
  } : t.variant === "outlined" ? {
    fontWeight: 600,
    fontSize: 14,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 8,
    textTransform: "none",
    color: r,
    borderColor: r,
    fontFamily: "inherit",
    "&:hover": {
      borderColor: r,
      backgroundColor: e ? "none" : `rgba(${l}, ${s}, ${a}, 0.08)`
    }
  } : {
    fontWeight: 600,
    fontSize: 14,
    transition: "all 0.2s ease-in-out",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 8,
    textTransform: "none",
    color: r,
    fontFamily: "inherit",
    cursor: n ? "not-allowed" : "pointer",
    border: "2px solid transparent",
    backgroundColor: `rgba(${l}, ${s}, ${a}, 0.08)`,
    // borderColor: customColor,
    "&:hover": {
      backgroundColor: e ? "none" : `rgba(${l}, ${s}, ${a}, 0.18)`
    }
  };
}), J = x.input((t) => {
  const { customColor: r } = t, e = y(r, 0.5);
  return {
    fontSize: 16,
    padding: "12px 16px",
    transition: "all 0.2s ease-in-out",
    border: `2px solid ${f[300]}`,
    fontFamily: "inherit",
    borderRadius: 8,
    outline: "none",
    "&:hover": {
      border: `2px solid ${f[400]}`
    },
    "&:active": {
      border: `2px solid ${e}`
    },
    "&:focus": {
      border: `2px solid ${e}`
      //GREY[300], // borderColor,
    }
  };
}), Z = x.input((t) => {
  const { customColor: r } = t;
  if (!r)
    return {};
  const e = y(r, 0.5);
  return {
    fontSize: 16,
    border: `2px solid ${f[300]}`,
    padding: "12px 16px",
    backgroundColor: "#fff",
    borderRadius: 8,
    transition: "all 0.2s ease-in-out",
    outline: "none",
    fontFamily: "inherit",
    "&:hover": {
      border: `2px solid ${f[400]}`
    },
    "&:active": {
      border: `2px solid ${e}`
    },
    "&:focus": {
      border: `2px solid ${e}`
      //GREY[300], // borderColor,
    }
  };
}), Q = x.textarea(
  (t) => {
    const { customColor: r } = t;
    if (!r)
      return {};
    const e = y(r, 0.5);
    return {
      fontSize: 16,
      resize: "none",
      border: `2px solid ${f[300]}`,
      padding: "12px 16px",
      backgroundColor: "#fff",
      borderRadius: 8,
      transition: "all 0.2s ease-in-out",
      outline: "none",
      fontFamily: "inherit",
      "&:hover": {
        border: `2px solid ${f[400]}`
      },
      "&:active": {
        border: `2px solid ${e}`
      },
      "&:focus": {
        border: `2px solid ${e}`
        //GREY[300], // borderColor,
      }
    };
  }
), v = x.div`
  display: flex;
  flex-direction: column;
`, k = x.div(() => ({}));
export {
  k as Box,
  ie as Form,
  _ as LanguageCode,
  K as QuestionType,
  v as Stack
};
